import { BybRewardColor } from "@Helpers/rewards-mappings";
import useI18n from "@i18n";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import dayjs from "dayjs";
import BybRewardIcon, { getRarityIcon } from "../icons/byb-reward-icon";
import BybListItem from "./byb-list-item";
import { IBybRewardListItemVariant } from "./byb-reward-list-item";

const BybRewardListItemRegular = ({
  name,
  scarcity,
  color,
  achieved = false,
  earnedAt,
  handleClick,
}: IBybRewardListItemVariant) => {
  const theme = useTheme();
  const { i18n } = useI18n();

  const rarityIcon = getRarityIcon(scarcity, color, theme);

  return (
    <Box
      sx={{
        ...(!achieved ? { filter: "grayscale(100%)", opacity: 0.5 } : {}),
      }}
    >
      <BybListItem
        header={
          <Stack direction={"row"} spacing={1}>
            <Typography variant={"textBase400"} color="dsBase.v200" sx={{ whiteSpace: "nowrap" }}>
              {name}
            </Typography>
          </Stack>
        }
        subHeader={
          <Stack direction="row" spacing={0.75} sx={{ alignItems: "center" }}>
            {rarityIcon}
            {scarcity && (
              <Typography variant="textS500" sx={{ color: "dsNeutral.v300", textTransform: "capitalize" }}>
                {i18n(`challenges.reward.scarcity.${scarcity}`)}
              </Typography>
            )}

            {earnedAt && (
              <>
                <Typography variant="textS500" color="dsNeutral.v300">
                  •
                </Typography>
                <Typography variant="textS500" sx={{ color: "dsNeutral.v300" }}>
                  {dayjs(earnedAt).format("DD MMM YYYY")}
                </Typography>
              </>
            )}
          </Stack>
        }
        backgroundColorGradient={color ? color : BybRewardColor[scarcity]}
        icon={<BybRewardIcon scarcity={scarcity} />}
        onClick={handleClick}
      />
    </Box>
  );
};

export default BybRewardListItemRegular;
